import ProductPage from '../../components/pages/Product';

const ProductInterest: React.FC = () => {
  return <ProductPage isInterestProductView={true} />;
};

export default ProductInterest;
